import Api from '../../../services';

export const getPayoutMethods = (params) => {
  return (dispatch) => {
    return Api.hostApi.payouts.getPayoutMethods(params).then((response) => {
      dispatch({
        type: 'GET_PAYOUTS_METHODS',
        data: response,
      });
      return response;
    });
  };
};

export const createPayoutMethod = (data) => {
  return (dispatch) => {
    return Api.hostApi.payouts.createPayoutMethod(data).then((response) => {
      dispatch({
        type: 'CREATE_PAYOUT_METHOD',
        data: response,
      });
      return response;
    });
  };
};

export const getPayoutMethod = (id) => {
  return (dispatch) => {
    return Api.hostApi.payouts.getPayoutMethod(id).then((response) => {
      dispatch({
        type: 'GET_PAYOUT_METHOD',
        data: response,
      });
      return response;
    });
  };
};

export const updatePayoutMethod = (id, data) => {
  return (dispatch) => {
    return Api.hostApi.payouts.updatePayoutMethod(id, data).then((response) => {
      dispatch({
        type: 'UPDATE_PAYOUT_METHOD',
        data: response,
      });
      return response;
    });
  };
};

export const deletePayoutMethod = (id) => {
  return (dispatch) => {
    return Api.hostApi.payouts.deletePayoutMethod(id).then((response) => {
      dispatch({
        type: 'DELETE_PAYOUT_METHOD',
        data: response,
      });
      return response;
    });
  };
};
